import React from 'react';

// Shown in place of an empty list/table body so a zero-record listing does not
// render as a bare table with no rows. Rendered as a table row (a single
// full-width cell) so it drops straight into an existing <tbody>.
const EmptyState = ({ colSpan = 1, message, icon = 'fa-inbox', action = null }) => {
  return (
    <tr>
      <td colSpan={colSpan}>
        <div className="dct-empty-state">
          <i className={`fa ${icon} dct-empty-state__icon`} aria-hidden="true"></i>
          <div className="dct-empty-state__text">{message}</div>
          {action && <div className="dct-empty-state__action">{action}</div>}
        </div>
      </td>
    </tr>
  );
};

export default EmptyState;
